import { RaceStatusEnum } from "@tvg/ts-types/Race";

export const COMMON_EVENT_NAMES = {
  SITE_CLICK: "Site Click",
  PAGE_VIEWED: "PAGE VIEWED",
  NAVIGATED: "Navigation Link Clicked"
};

export const PAGE_NAME_KEYS = {
  HOME: "home",
  TRACK_INFORMATION: "track_information",
  PROGRAM_PAGE: "program_page",
  PROMOS: "promos",
  PROMOTIONS: "promotions",
  PROMO_OFFER: "promo_offer"
};

export const MEP_PAGE_CONFIG = [
  {
    page: PAGE_NAME_KEYS.TRACK_INFORMATION,
    urlReg: /^\/racetracks((?!race=).)*$/
  },
  { page: PAGE_NAME_KEYS.PROGRAM_PAGE, urlReg: /\/racetracks\/.*\?race=.+/ },
  { page: PAGE_NAME_KEYS.PROMO_OFFER, urlReg: /\/?promo=(?!s\b)/ },
  { page: PAGE_NAME_KEYS.PROMOTIONS, urlReg: /(\/\w+)?#promos/ }
];

export const PAGE_NAMES = {
  [PAGE_NAME_KEYS.HOME]: "Home",
  [PAGE_NAME_KEYS.TRACK_INFORMATION]: "Track Information",
  [PAGE_NAME_KEYS.PROGRAM_PAGE]: "Program",
  [PAGE_NAME_KEYS.PROMOS]: "Promotions",
  [PAGE_NAME_KEYS.PROMOTIONS]: "Promotions",
  [PAGE_NAME_KEYS.PROMO_OFFER]: "Promo Offer"
};

export const TVG_PAGE_CONFIG = [
  {
    page: PAGE_NAME_KEYS.TRACK_INFORMATION,
    urlReg: /^\/racetracks((?!race=).)*$/
  },
  { page: PAGE_NAME_KEYS.PROGRAM_PAGE, urlReg: /\/racetracks\/.*\?race=.+/ },
  { page: PAGE_NAME_KEYS.PROMO_OFFER, urlReg: /\/promos\/[^?].+/ },
  { page: PAGE_NAME_KEYS.PROMOTIONS, urlReg: /^\/promos/ }
];

export const RACE_STATUS_MAPPER = {
  [RaceStatusEnum.OPEN]: "mtp",
  [RaceStatusEnum.UP_NEXT]: "mtp",
  [RaceStatusEnum.RACE_OFFICIAL]: "resulted",
  [RaceStatusEnum.RACE_OFF]: "race_off"
};

export const USE_OLD_PATHS = ["/tracks", "/races"];
